const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user_data';

export const setAuth = (token, user) => {
  try {
    if (!token || !user) {
      console.error('setAuth called with invalid data:', { token: !!token, user: !!user });
      return false;
    }
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    
    // Verify storage worked
    const storedToken = localStorage.getItem(TOKEN_KEY);
    const storedUser = localStorage.getItem(USER_KEY);
    
    if (storedToken && storedUser) {
      console.log('✅ Auth stored successfully for user:', user.email);
      return true;
    } else {
      console.error('❌ Failed to store auth data in localStorage');
      return false;
    }
  } catch (error) {
    console.error('❌ Error storing auth:', error);
    return false;
  }
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getUser = () => {
  const userData = localStorage.getItem(USER_KEY);
  return userData ? JSON.parse(userData) : null;
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
